import React from 'react'
import "./Text2.css"

const Text2 = (props) => {
    return <h1 className='text2'>{props.child}</h1>
}

export default Text2